import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function getReceiveItems() {
    // API request to get Receive Items

    try {
        const res = await axios.get(`${API_BASE_URL}/receive-items-list`);
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}


export async function getReceivesLoads(code: string, fromDate: string, toDate: string) {
    // API request to get Receives Loads
    const params = new URLSearchParams();
    params.append("code", code);
    params.append("fromDate", fromDate);
    params.append("toDate", toDate);

    try {
        const res = await axios.get(`${API_BASE_URL}/receives-loads`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}


export async function getReceivesLoadsByDate(siteName: string, fromDate: Date, toDate: Date) {
    // API request to get Receives Loads for a site for a specific date range
    const params = new URLSearchParams();
    params.append("siteName", siteName);
    params.append("fromDate", fromDate.toISOString());
    params.append("toDate", toDate.toISOString());

    try {
        const res = await axios.get(`${API_BASE_URL}/receives-loads-datetime`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}

export async function getReceivesLoadsAndLevels(site: string, day: string) {
    // API request to get Receives Loads for a site for a specific date range
    const params = new URLSearchParams();
    params.append("site", site);
    params.append("day", day);

    try {
        const res = await axios.get(`${API_BASE_URL}/receive-loads-and-levels-datetime`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}